/**
 * Type of pricing model used
 * tag: 1434
 * @readonly
 * @enum {number} (int)
 */
export enum ModelType {
  /** Utility provided standard model */
  UtilityProvidedStandardModel = 0,
  /** Proprietary (user supplied) model */
  ProprietaryModel = 1,
}
